import { render, staticRenderFns } from "./hotSaleList.vue?vue&type=template&id=dcafaf86&scoped=true&"
import script from "./hotSaleList.vue?vue&type=script&lang=js&"
export * from "./hotSaleList.vue?vue&type=script&lang=js&"
import style0 from "./hotSaleList.vue?vue&type=style&index=0&id=dcafaf86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcafaf86",
  null
  
)

export default component.exports